if (!customElements.get('contact-top')) {
  customElements.define('contact-top', class ContactTop extends HTMLElement {
    connectedCallback() {
      this.chatLink = this.querySelector('[data-contact-chat]');
      this.onChatClick = (event) => {
        if (!window.GorgiasChat) return;
        event.preventDefault();
        window.GorgiasChat.init().then(() => window.GorgiasChat.open());
      };
      this.chatLink?.addEventListener('click', this.onChatClick);
    }

    disconnectedCallback() {
      this.chatLink?.removeEventListener('click', this.onChatClick);
    }
  });
}
